import CompetitivenessStatusBreakdown from "./CompetitivenessStatusBreakdown/CompetitivenessStatusBreakdown"
import PriceMatchedOverview from "./PriceMatchedOverview/PriceMatchedOverview"
import PricingCompetitiveness from "./PricingCompetitiveness/PricingCompetitiveness"

const ProductPricing = () => {
  
  return (
    <section className='px-3 py-2'>
      
      <PricingCompetitiveness />

      <PriceMatchedOverview />

      <CompetitivenessStatusBreakdown />

    </section>
  )
}

export default ProductPricing
